"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.valueAndUnit = exports.relativeValue = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const luxon_1 = require("luxon");
const react_intl_1 = require("react-intl");
// Basically copied from lodash/isDate -> https://github.com/lodash/lodash/blob/master/isDate.js
const isDate = (value) => value && Object.prototype.toString.call(value) === "[object Date]";
const relativeValue = (dateValue, now, unit) => {
    const start = luxon_1.DateTime.fromJSDate(dateValue);
    const end = luxon_1.DateTime.fromJSDate(now);
    return Math.round(start.diff(end, unit).as(unit));
};
exports.relativeValue = relativeValue;
const SECOND = 1000;
const MINUTE = 60 * SECOND;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;
const WEEK = 7 * DAY;
const MONTH = 30 * DAY;
const YEAR = 365 * DAY;
const selectNearestUnit = (value, now) => {
    const diff = Math.abs(now.getTime() - value.getTime());
    if (diff >= YEAR) {
        return "year";
    }
    else if (diff >= MONTH) {
        return "month";
    }
    else if (diff >= WEEK) {
        return "week";
    }
    else if (diff >= DAY) {
        return "day";
    }
    else if (diff >= HOUR) {
        return "hour";
    }
    else if (diff >= MINUTE) {
        return "minute";
    }
    else {
        return "second";
    }
};
const valueAndUnit = (props, now) => {
    if (isDate(props.value)) {
        const unit = props.unit || selectNearestUnit(props.value, now);
        return {
            unit,
            value: (0, exports.relativeValue)(props.value, now, unit),
        };
    }
    return { value: props.value, unit: props.unit };
};
exports.valueAndUnit = valueAndUnit;
const RelativeTime = (props) => {
    const { value, unit } = (0, exports.valueAndUnit)(props, props.now || new Date());
    const wrappedProps = {
        ...props,
        // eslint-disable-next-line @typescript-eslint/prefer-as-const
        numeric: "auto",
        unit,
        value,
    };
    return React.createElement(react_intl_1.FormattedRelativeTime, { ...wrappedProps });
};
exports.default = RelativeTime;
